import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import GetBestWorstTopPlans from "../../api/performance/GetBestWorstTopPlans";
import { Link } from "react-router-dom";
import { Spin } from "antd";
import moment from "moment";
import { getTargetString } from "../../helpers/targetHelpers";

function AttentionRequired() {
  const [worstTopPlans, setWorstTopPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const positionState = useSelector((state) => state.positionState.value);

  useEffect(() => {
    getWorstPlans();
  }, [perfCycleState]);

  async function getWorstPlans() {
    setLoading(true);
    const apiResponse = await GetBestWorstTopPlans(
      positionState?.id,
      perfCycleState?.id
    );
    if (apiResponse.success) {
      // Get only the 3 worst performing plans
      setWorstTopPlans(apiResponse?.data?.worstTopPlans?.slice(0, 3) || []);
    }
    setLoading(false);
  }

  if (loading) {
    return (
      <div className="mb-6" style={{ background: "white", padding: "24px", borderRadius: "8px" }}>
        <div className="flex justify-center items-center" style={{ minHeight: "200px" }}>
          <Spin />
        </div>
      </div>
    );
  }

  if (!worstTopPlans || worstTopPlans.length === 0) {
    return null;
  }

  return (
    <div className="mb-6">
      <div 
        className="text-xl mb-4" 
        style={{ 
          color: "#201F1F",
          fontFamily: 'Inter, sans-serif',
          fontWeight: 600,
        }}
      >
        Attention Required
      </div>
      
      <div className="grid grid-cols-3 gap-4">
        {worstTopPlans.map((plan, index) => (
          <Link 
            key={plan.id} 
            to={`/top-plans/${plan.id}`}
            style={{ textDecoration: 'none' }}
          >
            <div
              style={{
                background: "rgba(255, 227, 219, 0.48)",
                padding: "20px",
                borderRadius: "8px",
                border: "none",
                cursor: "pointer",
                transition: "all 0.3s ease",
                height: "100%",
                boxShadow: index === 2 ? "0 4px 12px rgba(201, 44, 44, 0.7)" : "none",
              }}
              className="hover:shadow-md"
            >
              <div 
                style={{ 
                  color: "#201F1F",
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 600,
                  fontSize: "16px",
                  marginBottom: "12px",
                }}
              >
                {plan?.title}
              </div>
              
              <div 
                style={{ 
                  color: "#666",
                  fontFamily: 'Inter, sans-serif',
                  fontSize: "13px",
                  marginBottom: "8px",
                }}
              >
                {plan?.planGroup && (
                  <div style={{ marginBottom: "4px" }}>
                    <span style={{ 
                      background: "rgba(241, 90, 36, 0.1)", 
                      padding: "2px 8px", 
                      borderRadius: "4px",
                      fontSize: "12px",
                    }}>
                      {plan.planGroup}
                    </span>
                  </div>
                )}
              </div>
              
              <div 
                style={{ 
                  color: "#888",
                  fontFamily: 'Inter, sans-serif',
                  fontSize: "12px",
                  marginTop: "8px",
                }}
              >
                {index === 0 && "KPI performance dropped below target"}
                {index === 1 && plan?.targetDate && `Milestone deadline approaching in ${moment(plan.targetDate).diff(moment(), 'days')} days`}
                {index === 2 && "Risk level increased due to recent changes"}
              </div>
              
              {plan?.assignedTo && (
                <div 
                  style={{ 
                    color: "#666",
                    fontFamily: 'Inter, sans-serif',
                    fontSize: "12px",
                    marginTop: "8px",
                  }}
                >
                  {plan.assignedTo.firstName} {plan.assignedTo.lastName}
                  {plan.assignedTo.position?.name && ` • ${plan.assignedTo.position.name}`}
                </div>
              )}
              
              <div 
                style={{ 
                  color: "#201F1F",
                  fontFamily: 'Inter, sans-serif',
                  fontSize: "12px",
                  marginTop: "12px",
                  textAlign: "right",
                  textDecoration: "underline",
                }}
              >
                Review
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default AttentionRequired;
